<template>
<div class="card position-relative overflow-auto">
	<div class="dash-card-header"> 
		<div class="back-link ml-3">
		
		</div>
		<div class="title-div font-semibold"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("Language")}}</div>
		<div class="logout-link">
		</div>
	</div>
	<div class=" mt-20 text-center col-sm-12 ">
		<div v-for="(item, index) in languages" :key=index class=" ">
			<a class="col-xs-12 btn bg-color-grblue mt-5" :href="'/' + item.locale">{{item.name}}</a>
		</div>
	</div>
</div>
</template>

<script>
import repository from "@/api/repository";

export default {
	name: "Language",
	data() {
		return {
			languages: {}
		}
    },
	async mounted() {
		try {
			let { data } = await repository.getLanguages();
			this.languages = data;
		} catch (error) {
			this.error = error;
		}

	},
    methods: {
		hasHistory () { return window.history.length > 2 }
    }
}

</script>

<style scoped>

</style>